<div class="med-swiper-custom">
  <section class="docs-contaier">
    <!-- <div id="lightgalleryStoryDocs"> -->
      <ngx-glide [showArrows]="false" [showBullets]="false" [breakpoints]="breakpoints" [perView]="slidesPerView" [bound]="true" [gap]="0" arrowLeftLabel="" arrowRightLabel="">
        <a *ngFor="let doc of gallery; let i=index" [href]="doc.cdn_path" target="_blank">
          <img loading="lazy" class="docs-img" [attr.data-src]="doc.cdn_path" [alt]="doc?.detail_1" />
        </a>
      </ngx-glide>
    <!-- </div> -->
  </section>
</div>